var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext } from 'react';
import ThemeRoot from './ThemeRoot';
import defaultTheme from './defaultTheme';
import BreakpointsProvider from './BreakpointsProvider';
var ThemeContext = createContext(defaultTheme);
var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    // one level down merge of values
    // this way only what needs to change needs to be defined on custom theme
    var mergedTheme = {};
    Object.keys(defaultTheme).forEach(function (key) {
        mergedTheme[key] = __assign(__assign({}, defaultTheme[key]), theme[key]);
    });
    return (React.createElement(ThemeContext.Provider, { value: mergedTheme },
        React.createElement(ThemeRoot, null,
            React.createElement(BreakpointsProvider, null, children))));
};
ThemeProvider.defaultProps = {
    theme: {},
};
function useTheme() {
    return useContext(ThemeContext);
}
export { ThemeProvider as default, ThemeProvider, useTheme };
